var ApiServiceTypes;
(function (ApiServiceTypes) {
    ApiServiceTypes["BetsService"] = "betsService";
    ApiServiceTypes["UsersService"] = "usersService ";
    ApiServiceTypes["RoundsService"] = "roundsService";
    ApiServiceTypes["FreeChipService"] = "freeChipService";
    ApiServiceTypes["StatisticsService"] = "statisticsService";
    ApiServiceTypes["TranslationService"] = "translationService";
    ApiServiceTypes["ChatService"] = "ChatService";
})(ApiServiceTypes || (ApiServiceTypes = {}));

export { ApiServiceTypes };
